import React from 'react'
import { Topbar } from '@/components/ui/topbar'
import type { SearchResultItem } from '@/components/ui/SearchOverlay'

export interface CanonicalTopbarProps {
  onSearch?: (query: string) => void
  /**
   * Fires on every keystroke in the search overlay. Wires the input
   * value out so a parent can drive search-as-you-type by feeding
   * `searchResults` back in.
   */
  onSearchQueryChange?: (query: string) => void
  /**
   * Inline result list shown inside the search overlay (replaces the
   * default empty/no-results state). Consumer is responsible for
   * debouncing the query before fetching.
   */
  searchResults?: SearchResultItem[]
  /** Fires when the user clicks an item in `searchResults`. */
  onSearchResultClick?: (item: SearchResultItem) => void
  searchPlaceholder?: string
  notifications?: number
  showSidebarToggle?: boolean
  showSearch?: boolean
  showNotifications?: boolean
  showHelp?: boolean
  onSidebarToggle?: () => void
  user?: {
    id: string
    name: string
    email: string
    role: string
    department: string
    status: 'online' | 'offline' | 'away'
    plan: 'free' | 'pro' | 'enterprise'
    notifications: number
    verified: boolean
    location: string
    phone: string
    joinDate: string
  }
  quickActionsCount?: number
  className?: string
  helpUrl?: string
  showAdminMenuItems?: boolean
  /** Opens the DebugReport modal when clicked. Button renders next to the user menu. */
  onBugReport?: () => void
  /** Rendered inside the notifications popover when `notificationsPanel` is passed to Topbar. */
  notificationsPanel?: React.ReactNode
  /** Optional Wackler lens mode toggle rendered in the user utilities menu. */
  wacklerLens?: {
    active: boolean
    onToggle: () => void
  }
}

export function CanonicalTopbar({
  onSearch = () => {},
  onSearchQueryChange,
  searchResults,
  onSearchResultClick,
  searchPlaceholder,
  notifications = 0,
  showSidebarToggle = true,
  showSearch = true,
  showNotifications = true,
  showHelp = true,
  onSidebarToggle,
  user,
  quickActionsCount: _quickActionsCount = 2,
  className,
  helpUrl,
  showAdminMenuItems,
  onBugReport,
  notificationsPanel,
  wacklerLens,
}: CanonicalTopbarProps) {
  return (
    <Topbar
      onSearch={onSearch}
      onSearchQueryChange={onSearchQueryChange}
      searchResults={searchResults}
      onSearchResultClick={onSearchResultClick}
      searchPlaceholder={searchPlaceholder}
      showSearch={showSearch}
      showNotifications={showNotifications}
      showUserMenu={true}
      showHelp={showHelp}
      showSidebarToggle={showSidebarToggle}
      onSidebarToggle={onSidebarToggle}
      notifications={notifications}
      user={user}
      quickActions={[]}
      className={className}
      helpUrl={helpUrl}
      showAdminMenuItems={showAdminMenuItems}
      onBugReport={onBugReport}
      notificationsPanel={notificationsPanel}
      wacklerLens={wacklerLens}
    />
  )
}
